import React from 'react'

import { resolvePctLinkUrl } from '@/internal/utils/resolve-pctlink-url'
import Link from '@/components/link/link'

// @TODO: hangleMainMenu is not used when navigation-links is rendered outside of navigation
const NavigationLinks = ({
  items,
  className,
  showDescription = true,
  handleMainMenu
}) => {
  return (
    <ul data-cy="navigation-links" className={className}>
      {items?.map((item, index) => {
        const url = resolvePctLinkUrl(item)
        return (
          <li data-cy="navigation-link" key={`navigation-link-${index}`}>
            <Link
              to={url}
              openInNewWindow={item.openInNewWindow}
              onClick={() => handleMainMenu && handleMainMenu()}
            >
              {item.externalName}
            </Link>
            {showDescription && (
              <span className="descr">{item.description}</span>
            )}
          </li>
        )
      })}
    </ul>
  )
}

export default NavigationLinks
